export default __webpack_public_path__ + "static/social-trends_en-008dd58c4de421048d5bb2603d034245.png";